// Create a small element at the top of the page to observe
const topMarker = document.createElement('div');
topMarker.style.position = 'absolute';
topMarker.style.top = '0';
topMarker.style.height = '10px';
topMarker.style.width = '1px';
topMarker.style.pointerEvents = 'none';
topMarker.id = 'scroll-marker';
document.body.prepend(topMarker);


const farMarker = document.createElement('div');
farMarker.style.position = 'absolute';
farMarker.style.top = '0px';
farMarker.style.height = '50vh';
farMarker.style.width = '1px';
farMarker.style.pointerEvents = 'none';
farMarker.id = 'far-marker';
document.body.prepend(farMarker);


// Set up IntersectionObserver
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // Remove class when the marker is visible
            document.body.classList.remove('scrolled');
        } else {
            // Add class when the marker is not visible
            document.body.classList.add('scrolled');
        }
    });
}, {
    root: null, // Use the viewport as the root
    threshold: [0], // Trigger when any part of the element is visible
});


// Set up IntersectionObserver
const farobserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // Remove class when the marker is visible
            document.body.classList.remove('farscrolled');
        } else {
            // Add class when the marker is not visible
            document.body.classList.add('farscrolled');
        }
    });
}, {
    root: null, // Use the viewport as the root
    threshold: [0], // Trigger when any part of the element is visible
});


// Start observing the top marker
document.addEventListener('DOMContentLoaded', () => {
    observer.observe(topMarker);
    farobserver.observe(farMarker);
});
